/**
 * Alumnia brand logo constants.
 * The "A" glyph is extracted from Playfair Display Bold as a vector path — no font dependency.
 */

/** Playfair Display Bold "A" glyph as SVG path data */
export const ALUMNIA_A_PATH =
  'M368 710 611 84Q625 48 642.5 34.5Q660 21 674 20V0Q644 2 603.5 2.5Q563 3 522 3Q476 3 435.0 2.5Q394 2 370 0V20Q421 22 434.5 37.5Q448 53 428 104L368 268H150L124 199Q102 144 97.5 109.0Q93 74 102.5 55.0Q112 36 133.5 28.5Q155 21 185 20V0Q152 2 122.0 2.5Q92 3 61 3Q39 3 19.5 2.5Q0 2 -15 0V20Q6 24 28.0 47.0Q50 70 71 125L299 710Q315 709 333.5 709.0Q352 709 368 710ZM361 288 262 558 158 288Z'

/** Transform to position the glyph within a 512×512 viewBox */
export const ALUMNIA_A_TRANSFORM = 'translate(137.19,384.00) scale(0.360563,-0.360563)'

/** Brand blue color */
export const ALUMNIA_BLUE = '#1e3a8a'

/**
 * Build a complete Alumnia logo SVG string.
 * Useful for data URIs in ImageResponse (OG images, apple-icon).
 */
export function buildLogoSvg(options?: {
  size?: number
  bgColor?: string
  fgColor?: string
  rx?: number
}): string {
  const { size = 512, bgColor = ALUMNIA_BLUE, fgColor = 'white', rx = 80 } = options ?? {}
  return `<svg width="${size}" height="${size}" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="512" height="512" rx="${rx}" fill="${bgColor}"/><g transform="${ALUMNIA_A_TRANSFORM}"><path d="${ALUMNIA_A_PATH}" fill="${fgColor}"/></g></svg>`
}

/**
 * Build the Alumnia lettermark SVG (just the "A" on a full-bleed background, no rounded rect).
 * Used for splash screens and other full-canvas contexts.
 */
export function buildSplashSvg(options?: {
  size?: number
  bgColor?: string
  fgColor?: string
}): string {
  const { size = 512, bgColor = ALUMNIA_BLUE, fgColor = 'white' } = options ?? {}
  return `<svg width="${size}" height="${size}" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="512" height="512" fill="${bgColor}"/><g transform="${ALUMNIA_A_TRANSFORM}"><path d="${ALUMNIA_A_PATH}" fill="${fgColor}"/></g></svg>`
}
